var map = {
	"./hourglass.svg": "833a",
	"./hourglass_dark.svg": "72ec",
	"./icon_calendar.svg": "750d",
	"./icon_calendar_dark.svg": "c147",
	"./icon_city.png": "c479",
	"./icon_dice.svg": "3b6e",
	"./icon_friends.png": "80bf",
	"./icon_people.png": "aa4f",
	"./icon_presentation.png": "bdc3",
	"./icon_university.png": "0b52",
	"./info.svg": "76ed",
	"./info_dark.svg": "1074",
	"./inv.jpg": "d08f",
	"./map-location.svg": "cc46",
	"./map-location_dark.svg": "861d5",
	"./stopwatch.svg": "aac5",
	"./stopwatch_dark.svg": "32dd",
	"./users.svg": "d956",
	"./users_dark.svg": "7efc",
	"./wtch.jpg": "9303"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";